<template>
  <div class="rtl">
    <m-form
      title="کد های معرف"
      :apiUrl="baseUrl"
      :cols="cols"
      :isEditing.sync="isEditing"
      :canDelete="canDelete"
      :canSubmit="true"
      :show-navigation-btns="false"
      :showListBtn="false"
      :showListExportBtn="false"
      :list_filters="filters"
      @click:row="setItem"
      @clearForm="clearForm"
      @submit="submit"
      @delete="deleteItem"
      ref="form"
    >
      <template #default>
        <v-row>
          <v-col cols="12">
            <v-text-field label=" * کد" v-model="item.code" :disabled="!isEditing" class="rounded-lg" />
          </v-col>
          <v-col cols="12">
            <v-textarea
              label="توضیحات"
              v-model="item.explanation"
              :disabled="!isEditing"
              height="105"
              class="rounded-lg"
            ></v-textarea>
          </v-col>
          <v-col cols="12">
            <v-switch label="فعال" v-model="item.is_active" :disabled="!isEditing" />
          </v-col>
        </v-row>
      </template>
    </m-form>
  </div>
</template>
<script>
import MFormMixin from "@/components/m-form/MForm.js";

export default {
  mixins: [MFormMixin],
  props: {},
  data() {
    return {
      baseUrl: "sobhanAdmin/referralCodes/",
      appendSlash: true,
      serverProcessing: true,
      items: [],
      cols: [
        {
          text: "کد",
          value: "code",
        },
        {
          text: "توضیحات",
          value: "explanation",
        },
        {
          text: "تاریخ ایجاد",
          value: "created_at",
        },
        {
          text: "فعال",
          value: "is_active",
          type: "boolean",
        },
      ],
      filters: {},
    };
  },
  created() {
    this.item = this.getItemTemplate();
  },
  mounted() {
    console.log(this.appendSlash);
  },
  methods: {
    setItem(item) {
      this.item = { ...item };
    },
    getItemTemplate() {
      return {};
    },
  },
};
</script>
